module.exports = __webpack_public_path__ + "media/dashboard/assets/images/inbox_icons/gmail-badge-nocolor-7d5c45c0c6da6638fe9c7d7590e218b9.svg";